import {observer} from 'mobx-react';
import React, {Component} from 'react';

import {withI18n, WithI18nProps} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

import styles from './topic-content.module.less';
import {TopicListStore} from './topic-list-collection.mobx-store';
import {TopicTable} from './topic-table.react-component';

export interface TopicContentProps extends WithI18nProps {
    store: TopicListStore;
    pageSize: number;
}

@observer
class _TopicContent extends Component<TopicContentProps> {
    loadTopics = () => {
        this.props.store.loadTopics(this.props.pageSize);
    };

    render() {
        return (
            <>
                <div data-testid="topic-table">
                    <TopicTable
                        items={this.props.store.items}
                        isLoading={this.props.store.isLoading}
                    />
                    {this.props.store.hasMore && (
                        <div className={styles['load-more']}>
                            <Button
                                data-testid="load-more"
                                onClick={this.loadTopics}
                                disabled={this.props.store.isLoading}
                            >
                                {this.props.store.isLoading
                                    ? this.props.gettext('Loading...')
                                    : this.props.gettext('See more')}
                            </Button>
                        </div>
                    )}
                </div>
            </>
        );
    }
}

export const TopicContent = withI18n(_TopicContent);
